import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.bookTest || initialState;

export const selectCompanies = createSelector([selectDomain], (state) =>
  state.companies?.map((company) => ({
    label: company.companyName,
    value: company._id,
  }))
);

export const selectUsers = createSelector([selectDomain], (state) =>
  state.companyUsers?.users?.map((user) => ({
    label: `${user.firstName} ${user.lastName || ""}`,
    value: user._id,
  }))
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectCatalog = createSelector(
  [selectDomain],
  (state) => state.catalog
);

export const selectUserAddress = createSelector([selectDomain], (state) => {
  const user = state.user;
  const billingAddress = user?.billingAddress || [];
  const pickupAddress = user?.pickupAddress || [];
  return {
    billingAddress,
    pickupAddress,
  };
});

/* export const selectTestCategories = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const testCategories = [];
  const selectedCategories = [];
  catalog.forEach((item) => {
    const test = item.test;
    const testCategory = test.testCategory;
    const selectedCatIndex = selectedCategories.indexOf(testCategory._id);
    if (selectedCatIndex === -1) {
      selectedCategories.push(testCategory._id);
      testCategories.push({
        title: testCategory.name,
        key: testCategory._id,
        value: testCategory._id,
        children: [
          {
            title: (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>{test.parameter}</p>
                <p>₹{item.price}</p>
              </div>
            ),
            key: test._id,
            value: item._id,
            //cod: "cod",
          },
        ],
      });
    } else {
      // add test to children
      const testIndex = testCategories[selectedCatIndex].children.findIndex(
        (item) => item.key === test._id
      );
      if (testIndex === -1) {
        testCategories[selectedCatIndex].children.push({
          title: (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>{test.parameter}</p>
              <p>₹{item.price}</p>
            </div>
          ),
          key: test._id,
          value: item._id,
          //cod: "cod",
        });
      }
    }
  });
  return testCategories;
});
 
export const selectCommodities = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const options = [];
  catalog.forEach((item) => {
    const test = item.test;
    const commodity = test.commodity;
    const commodityCategory = test.commodityCategory;

    const index = options.findIndex(
      (opt) => opt.label === commodityCategory.name
    );
    const commodityOption = { label: commodity.name, value: commodity._id };
    if (index === -1) {
      options.push({
        label: commodityCategory.name,
        options: [commodityOption],
      });
    } else {
      // check if commodity already exists in category
      const optIndex = options[index].options.findIndex(
        (cat) => cat.value === commodity._id
      );
      if (optIndex === -1) {
        options[index].options.push(commodityOption);
      }
    }
  });
  return options;
});*/

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);
